import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatIconExternalLinkBox } from 'blocks-nextjs/blocks-react/components/Icons/ExternalLinkBox';
import styles from './FooterLegalLinks.module.scss';
import cx from 'classnames';
export const FooterLegalLinks = ({ legalLinks, isFooterDesignUpdate, isFooterLinksSortActive }) => {
    const ShouldShowIcons = isFooterDesignUpdate;
    return (_jsx("div", { className: isFooterLinksSortActive
            ? styles['footer__legal__links__sort-box']
            : styles['footer__legal__links-box'], children: legalLinks
            ?.filter((legalLink) => legalLink.display)
            .map((legalLink) => (_jsx("a", { href: legalLink.url, target: legalLink.target, className: cx(styles['footer__legal__links-link'], legalLink.className, 'exclude-global', {
                [styles['with-icon']]: ShouldShowIcons
            }), "aria-label": legalLink.label, suppressHydrationWarning: true, children: _jsxs("div", { className: cx(styles['footer__legal__links-link-container']), children: [ShouldShowIcons && (_jsx(CatIconExternalLinkBox, { className: styles['footer__legal__links-icon'] })), legalLink.label] }) }, legalLink.name))) }));
};
